// import firebase from "firebase";
import firebase from "firebase/app";
// import 'firebase/auth';
import "firebase/auth/dist/index.cjs";
import "firebase/storage/dist/index.cjs";
// import "firebase/database/dist/index.cjs";
import "firebase/messaging/dist/index.cjs";
require("firebase/firestore/dist/index.cjs");
require("firebase/functions/dist/index.cjs");

const config = {
  apiKey: "AIzaSyD-i9OsunwYMYn7FVwCc75bAGsrnph6Hj4",
  authDomain: "guarentee-app.firebaseapp.com",
  databaseURL: "https://guarentee-app.firebaseio.com",
  projectId: "guarentee-app",
  storageBucket: "guarentee-app.appspot.com",
  messagingSenderId: "909722395500"
};
firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;



// WEBPACK FOOTER //
// ./src/utils/firebase.js